export default __webpack_public_path__ + "static/media/ErrorNoCode.fdc26968.png";